<template>
  <div>
    <div class="title">
      <span class="name">重点学科</span>
      <span class="title-t" :class="{ nav: nav == 1 }" @click="getNav(1)">国家重点培育学科</span>
      <span class="title-t" :class="{ nav: nav == 2 }" @click="getNav(2)">国家一级重点学科</span>
      <span class="title-t" :class="{ nav: nav == 3 }" @click="getNav(3)">国家二级重点学科</span>
    </div>
    <span class="specialty_name" v-for="(item, i) in importantSpecialtyList" :key="i">
      {{ item.specialty_name }}
    </span>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      list: null,
      importantSpecialtyList: null,
      nav: null
    };
  },
  computed: {
  },
  created() {
    this.getImportant()
  },
  methods: {
    getImportant() {
      this.$fecth
        .get("school/getImportant", { params: { school_id: this.$route.query.cid } })
        .then((res) => {
          res = res.data
          if(res.length>0) {
            this.importantSpecialtyList = res
            this.list = res
          } else {
            this.$emit('getImportState', false)
          }
          
        });
    },
    getNav(e) {
      if (this.nav == e) {
        this.nav = null
        this.importantSpecialtyList = this.list
      } else {
        this.nav = e
        let specialtyList = []
        this.list.forEach(element => {
          if (e == 1 && element.level == '国家重点培育学科') {
            specialtyList.push(element)
          }
          if (e == 2 && element.level == '国家一级重点学科') {
            specialtyList.push(element)
          }
          if (e == 3 && element.level == '国家二级重点学科') {
            specialtyList.push(element)
          }

        });
        this.importantSpecialtyList = specialtyList
      }
    }
  },
};
</script>

<style scoped lang='less'>
.title {
  font-size: 22px;
  margin-bottom: 15px;

  .name {
    margin-right: 70px;
  }

  .title-t {
    border: 1px solid #4591F6;
    color: #4591F6;
    margin-right: 20px;
    padding: 2px 10px;
    border-radius: 5px;
    font-size: 18px;
  }
}

.specialty_name {
  background: #F5F5F5;
  display: inline-block;
  margin-top: 20px;
  margin-right: 20px;
  padding: 2px 5px;
  border-radius: 3px;
}

.nav {
  background: #4591F6;
  color: white !important;
}
</style>
